import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { API_ENDPOINTS } from '@typings/api-endpoints.type';
import { ApiQueryParams } from '@utils/api-query-params.type';
import { buildQueryParams } from '@utils/query';
import { map, Observable, of } from 'rxjs';
import {
  CreateRequest,
  GetAllRequestResponse,
  GetRequestsCountResponse,
  GetRequestToEditResponse,
  Request,
} from '../../domain/entities/requests.entity';
import { RequestsServices } from '../../domain/services/requests.service';

@Injectable()
export class RequestsServicesImpl implements RequestsServices {
  constructor(private client: HttpClient) {}
  getAllRequests(companyId: string): Observable<GetAllRequestResponse> {
    const params = new HttpParams()
      .set('_companyId', companyId)
      .set('populate', 'action,requester,approver')
      .set(
        'deepPopulate',
        `{"path":"approver","populate":{"path":"_profilePicture"}}`
      );
    return this.client
      .get<GetAllRequestResponse>(
        environment.apiDomain + API_ENDPOINTS.REQUEST.GET_ALL(),
        {
          params,
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  createRequest(request: CreateRequest): Observable<GetAllRequestResponse> {
    return this.client
      .post<GetAllRequestResponse>(
        environment.apiDomain + API_ENDPOINTS.REQUEST.CREATE(),
        request
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  editRequest(request: Request): Observable<any> {
    return this.client
      .post<GetAllRequestResponse>(
        environment.apiDomain + API_ENDPOINTS.REQUEST.UPSERT(),
        request
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  exportRequests(requests: Request[]): Observable<any> {
    return of({
      data: [
        {
          id: '1',
          name: 'David Warret',
          action: 'Contract Signing',
          amount: '300',
          approver: 'David Holifield',
          status: 'Pending',
          urgent: true,
          date: '25/06/2021',
        },
      ],
    });
  }
  myRequests(query: ApiQueryParams): Observable<GetAllRequestResponse> {
    const params = buildQueryParams(query).set(
      'deepPopulate',
      `{"path":"approver","populate":{"path":"_profilePicture"}}`
    );

    return this.client
      .get<GetAllRequestResponse>(
        // environment.apiDomain + API_ENDPOINTS.REQUEST.MY_REQUESTS(),
        environment.apiDomain + API_ENDPOINTS.REQUEST.GET_ALL(),
        {
          params,
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getRequestById(requestId: string): Observable<GetRequestToEditResponse> {
    const params = new HttpParams()
      // .set('_id', requestId)

      .set('populate', '_action,requester,approvals')
      .set(
        'deepPopulate',
        `{"path":"approvals","populate":{"path":"approver"}}`
      );
    return this.client
      .get<GetRequestToEditResponse>(
        environment.apiDomain +
          API_ENDPOINTS.REQUEST.REQUEST_DETAILS(requestId),
        { params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getMyRequestsCount(userId: string): Observable<GetRequestsCountResponse> {
    const params = new HttpParams()
      .set('filter', `{"_requester":"${userId}", "status":"pending"}`)
      .set('populate', 'requester,approver');

    return this.client
      .get<GetRequestsCountResponse>(
        environment.apiDomain + API_ENDPOINTS.REQUEST.REQUESTS_COUNT(userId),
        { params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
}
